/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['[_nghost-%COMP%]{display:inline-block;position:relative}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2tub2Iva25vYi5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC9rbm9iL2tub2IuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/knob/knob.component.scss.shim.ngstyle.ts